var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropperAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2205 3.42518C11.651 2.99467 12.349 2.99467 12.7795 3.42518L20.5747 11.2204C21.0052 11.6509 21.0052 12.3489 20.5747 12.7794L19.0157 14.3385C18.5851 14.769 17.8871 14.769 17.4566 14.3385L9.66144 6.54326C9.23093 6.11274 9.23093 5.41474 9.66144 4.98422L11.2205 3.42518Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8307 10.0512L2.64577 18.2361C1.78474 19.0972 1.78474 20.4932 2.64577 21.3542C3.50681 22.2153 4.90282 22.2153 5.76385 21.3542L13.9487 13.1693L10.8307 10.0512Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4054 7.71269L21.3542 5.76385C22.2153 4.90282 22.2153 3.50681 21.3542 2.64577C20.4932 1.78474 19.0972 1.78474 18.2361 2.64577L16.2873 4.59462L19.4054 7.71269Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropperAlt);
export default __webpack_public_path__ + "static/media/dropper-alt.2920c860e6318e19162f8d7b919287bb.svg";
export { ForwardRef as ReactComponent };